<template>
  <div class="myInvest" :class="{ isiOSX: isiOSX }">
    <van-nav-bar class="invest-title" :fixed="true" :title="title" />
    <img
      @click="goBack()"
      class="invest-reback"
      src="../../assets/myInvest/reback.png"
    />
    <myInvest />
  </div>
</template>

<script>
import myInvest from "./order.vue";
export default {
  components: {
    myInvest,
  },
  data() {
    return {
      title: "众筹项目",
      isiOSX: false,
    };
  },
  created() {
    this.$api.setToken(this.$route.query.token);
    this.isiOSX = this.isIphoneX();
  },
  methods: {
    goBack() {
      this.params("", "", "goBack");
    },
  },
};
</script>

<style lang="less">
.myInvest {
  background-color: #f2f2f2;
  height: 100%;
  .van-tabbar {
    height: 49px;
    box-shadow: 0 -1px 0 #eee;
    .van-tabbar-item {
      color: #333;
      font-size: 11px !important;
    }
  }
  .invest {
    &-title {
      z-index: 2 !important;
      height: 44px;
      line-height: 44px;
      padding-top: 24px;
      box-shadow: 0 1px 0 #eee;
      .van-nav-bar__title {
        color: #333;
        font-size: 17px;
        font-weight: 700;
      }
    }
    &-reback {
      width: 15px;
      padding: 12px 15px;
      position: fixed;
      top: 29px;
      left: 0;
      z-index: 2;
    }
  }
}
.isiOSX {
  .invest {
    &-title {
      padding-top: 44px;
    }
    &-reback {
      top: 49px;
    }
  }
}
</style>
